import { render } from "./BuyInsuranceComponent.vue?vue&type=template&id=73c0efe4&ts=true"
import script from "./BuyInsuranceComponent?vue&type=script&lang=ts"
export * from "./BuyInsuranceComponent?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/atlantis/atlantis/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__